import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

export type AvatarType = 'solid' | 'outlined' | 'logo'

export type AvatarSize = 'large' | 'small' | 'extra-small'

@Component({
  selector: 'td-wb-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [NgClass, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
  initials: InputSignal<string | undefined> =  input<string>();
  avatarType: InputSignal<AvatarType> =  input<AvatarType>('outlined');
  avatarSize: InputSignal<AvatarSize> =  input<AvatarSize>('large');

  hasInitials(): boolean {
    return this.initials() !== undefined;
  }

  isOutlined(): boolean {
    return this.avatarType() === 'outlined';
  }

  isLogo(): boolean {
    return this.avatarType() === 'logo';
  }

  isSmall(): boolean {
    return this.avatarSize() === 'small';
  }

  isExtraSmall(): boolean {
    return this.avatarSize() === 'extra-small';
  }
}
